import { createRouter, createWebHistory } from 'vue-router'
import AboutPage from '../views/AboutPage.vue'
import ContactPage from '../views/ContactPage.vue'
import TherapyPage from '../views/TherapyPage.vue'
import SupervisionS from "@/views/SupervisionS.vue";
import HomeView from "@/views/HomeView.vue";
import PrivacyP from "@/views/PrivacyP.vue";


const routes = [
    { path: '/', component: HomeView },
    { path: '/about', component: AboutPage },
    { path: '/therapy', component: TherapyPage },
    { path: '/SupervisionS', component: SupervisionS },
    { path: '/contact', component: ContactPage },
    { path: '/privacy', component: PrivacyP}
]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

export default router
